import OmnyConfirmContinueModal from './OmnyConfirmContinueModal.vue';
export default {
  name: 'OmnyDeleteModal',
  components: {
    OmnyConfirmContinueModal
  },
  emits: ['update:modelValue', 'cancel', 'delete'],
  props: {
    modelValue: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    modal: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit('update:modelValue', val);
      }
    }
  }
};